import { fromEvent, map, startWith } from 'rxjs';
// thanks to Gary Grossgarten @ https://github.com/garygrossgarten/media-query for providing this example!
export function matchMedia$(query) {
  const mediaQuery = window.matchMedia(query);
  return fromEvent(mediaQuery, 'change').pipe(startWith(mediaQuery), map(list => list.matches));
}